import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import History from './components/History';
import Deities from './components/Deities';
import Stotras from './components/Stotras';
import Mahotsavam from './components/Ulsavam';
import Donations from './components/Donations';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <History />
      <Deities />
      <Stotras />
      <Mahotsavam />
      <Donations />
      <Footer />
    </div>
  );
}

export default App;